import React from "react";
import { Badge } from "antd";
const SIZE = 18;
const CustomBadge = ({ count }) => {
  return (
    <Badge
      showZero
      style={{
        backgroundColor: " #4B4E6A",
        minWidth: SIZE,
        height: SIZE,
        borderRadius: 2,
        fontSize: "14px",
        fontFamily: "Work Sans, sans-serif",
        fontWeight: 600,
        display: "flex",
        justifiyItems: "center",
        alignItems: "center",
        marginLeft: 4
      }}
      count={count}
    ></Badge>
  );
};

export default CustomBadge;
